// Mocking is off in every configuration but `mock`, which replaces this file with mocking.mock.ts (see angular.json),
// so MSW and the generated mocks never reach the other builds.
export async function enableMocking(): Promise<void> {
  // Nothing to start.
}
